import { ActivityLabelConditionTypeEnum, ActivityLabelTargetEnum } from '@workalizer/shared/enums';
import { z } from 'zod';
export var ActivityLabelConditionSchema = z.object({
    type: z.nativeEnum(ActivityLabelConditionTypeEnum),
    keyword: z.string().min(1)
});
export var ActivityLabelRuleSchema = z.object({
    target: z.nativeEnum(ActivityLabelTargetEnum),
    conditions: z.array(ActivityLabelConditionSchema).min(1)
});
export var ActivityLabelSchema = z.object({
    name: z.string().min(1),
    rules: z.array(ActivityLabelRuleSchema).min(1)
});
export var AILabelsResponseSchema = z
    .array(ActivityLabelSchema)
    .min(2)
    .max(5);
